// extracted by mini-css-extract-plugin
module.exports = {"EditorPersonal":"_3hvnlPRA","block":"_1y3ELh_L","blockFlex":"_1xde-2_S","inputsContainer":"_33-CpJWT","scrollDiv":"_1sAuHd5T","firstInput":"CmQpezNq","nameInputs":"_2lEyWCSW","backButton":"h2QVKnoR","backButtonContainer":"jyGuVxwp"};
    if(module.hot) {
      // 1754515042634
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  